module.exports = __webpack_public_path__ + "media/images/paris_02_small-3be7b0d0f186e91f551699fd6472c571.jpg";